import React from 'react';
import { MDBIcon, MDBNavLink } from 'mdbreact';
import { useSelector,useDispatch } from '../../reducers/store'
import { saveUser } from '../../reducers/users'
import ItemEditComponent from '../../components/TextEdit'
import './account-view.css'

const AccountView = ({ title }) => {
    const dispatch = useDispatch();

    const { user } = useSelector((state) => state.users);

    const [edit, setEdit] = React.useState(true);
    const [profile, setProfile] = React.useState(user);

    const SaveUser = () => {
        dispatch(saveUser(profile));
    }
    const onChangeText = (key, value) => {
        console.log(key, value);
        let newProfile = {
            ...profile,
            [key]: value
        };

        setProfile({ ...newProfile });
    }

    return (
        <div className="content-wrapper p-2 account-container">
            {/* Page Header */}
            <div className="account-page-header">
                <h1 className="account-page-title">
                    <i className="fas fa-user-circle"></i>
                    Profile Settings
                </h1>
            </div>

            {/* Main Content Card */}
            <div className="account-content-card">
                <div className="account-card-header">
                    <h2 className="account-card-title">
                        <i className="fas fa-user-edit"></i>
                        Personal Information
                    </h2>
                </div>

                <div className="account-info-box">
                    <i className="fas fa-info-circle"></i>
                    <span>Update your personal information below. Username cannot be changed.</span>
                </div>

                <div className="account-form-group">
                    <label className="account-form-label">Username</label>
                    <input
                        type="text"
                        className="account-form-control"
                        value={profile.username || ''}
                        disabled
                    />
                </div>

                <div className="account-form-group">
                    <label className="account-form-label">Name</label>
                    <input
                        type="text"
                        className="account-form-control"
                        value={profile.name || ''}
                        onChange={(e) => onChangeText('name', e.target.value)}
                    />
                </div>

                <div className="account-form-group">
                    <label className="account-form-label">Surname</label>
                    <input
                        type="text"
                        className="account-form-control"
                        value={profile.surname || ''}
                        onChange={(e) => onChangeText('surname', e.target.value)}
                    />
                </div>

                <div className="account-form-group">
                    <label className="account-form-label">Email</label>
                    <input
                        type="email"
                        className="account-form-control"
                        value={profile.email || ''}
                        onChange={(e) => onChangeText('email', e.target.value)}
                    />
                </div>

                <div className="account-form-group">
                    <label className="account-form-label">Phone Number</label>
                    <input
                        type="tel"
                        className="account-form-control"
                        value={profile.phoneNumber || ''}
                        onChange={(e) => onChangeText('phoneNumber', e.target.value)}
                        placeholder="+27 XX XXX XXXX"
                    />
                </div>

                <button type='button' className='account-save-button' onClick={() => { SaveUser() }}>
                    <i className="fas fa-save"></i>
                    Save Changes
                </button>
            </div>
        </div>
    );
};

export default AccountView;
